<template>
  <form @submit.prevent="onSubmit">
    <div class="relative text-black mt-4">
      <input
        type="search"
        name="search"
        placeholder="Zoeken"
        v-model="search_string"
        class="bg-gray-100 w-full h-10 px-5 pr-10 rounded-lg text-sm focus:outline-none border-gray-700 border font-opensans mt-4"
      />
      <button
        type="submit"
        class="absolute right-0 bg-gray-100 h-10 rounded-r-lg w-8 text-mi-blue-500 border-gray-700 border hover:text-gray-100 hover:bg-mi-blue-500 mt-4 focus:outline-none"
      >
        <i class="material-icons px-0 pt-2 cursor-pointer">search</i>
      </button>
    </div>
  </form>
</template>
<script>
export default {
  name: "TextSearch",

  data() {
    return {
      local_search_string: null
    };
  },
  methods: {
    onSubmit() {
      this.$store.dispatch("update_search", {
        selected: this.local_search_string,
        filtername: "search_string"
      });
      if (this.$router.currentRoute.name !== "Home")
        this.$router.push({ name: "Home" });
    }
  },
  computed: {
    search_string: {
      get() {
        return this.$store.state.search["search_string"];
      },
      set(val) {
        this.local_search_string = val;
      }
    }
  }
};
</script>
